<template>
    <div>
        <div class="content contentRecord"  v-for="(value,index) in arr" :key="index">
            <template v-if="index==0">
                <BigTitle title='part.4 咨询记录'></BigTitle>
                <MiddleTitle title='咨询记录'></MiddleTitle>
            </template>
            <table>
                <thead>
                    <tr>
                        <!-- <th>咨询次数</th> -->
                        <th>时间</th>
                        <th>咨询类别</th>
                        <th width="340">主题</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(val,idx) in value" :key="idx">
                        <!-- <th>第{{val.interviewNum}}次咨询</th> -->
                        <td>{{val.interviewTime}}</td>
                        <td>{{val.categoryName}}</td>
                        <td>{{val.interviewTheme}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import BigTitle from './bigTitle'
import MiddleTitle from './middleTitle'
import SmallTitle from './smallTitle'
export default {
    name: "consultativeRecord",
    props: ['consultativeRecord'],
    components: {
        BigTitle,MiddleTitle,SmallTitle
    },
    data() {
        return {
        }
    },
    computed: {
        arr() {
            let arr = [];
            let consultativeRecord = this.consultativeRecord;
            for(let i=0,len=consultativeRecord.length;i<len;i+=20){
                arr.push(consultativeRecord.slice(i,i+20));
            }
            return arr;
        }
    },
    methods: {

    },
}
</script>
<style lang="less">

</style>